/**
* Created by lobin on 2020/6/17.
*/
<template>
  <div class="cabinet-grid-tree-select">
    <a-tree-select
        v-model="value"
        show-search
        allowClear
        ref="treeSelect"
        @search="search"
        tree-data-simple-mode
        @select="select"
        style="width: 100%"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :tree-data="treeData"
        placeholder="请选择格子"
        :load-data="onLoadData"
    />
  </div>
</template>

<script type="text/babel">
import { cabinetgroup, cabineTreeData } from '@/api/cabinet';

export default {
  data() {
    return {
      value: undefined,
      treeData: [],
    };
  },
  created() {
    this.getCabinetGroup('');
  },
  watch: {
    value(val) {
      if (!val) this.$emit('input', {});
    },
  },
  methods: {
    async getCabinetGroup(keyWord) {
      const { data } = await cabinetgroup(keyWord);
      this.treeData = data;
      // this.$refs.treeSelect.update();
    },
    onLoadData(treeNode) {
      const { id } = treeNode.dataRef;
      const arr = id.split('-');
      return cabineTreeData({
        stationId: arr[0],
        cabnum: arr[1],
      }).then(({ data }) => {
        this.treeData = this.treeData.concat(data);
      });
    },
    select(val, { isLeaf }) {
      if (isLeaf) {
        this.$emit('input', { cabinetId: val });
      } else {
        const arr = val.split('-');
        if (arr.length === 2) {
          this.$emit('input', { stationId: arr[0], cabNum: arr[1] });
        } else {
          this.$emit('input', { stationId: arr[0] });
        }
      }
    },
    search(value) {
      this.getCabinetGroup(value);
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
.cabinet-grid-tree-select{
  width: 200px;
}
</style>
